export default "__VITE_ASSET__BXx$68Wr__"